

import { 
  UPDATE_LOADING_STATUS,
  UPDATE_FORM_VALUE,
  GET_NETWORK
} from "../actions/network";

const defVal = {
  loading: true,
  networkInfo: {},
};

export default (state = defVal, action) => {
  switch (action.type) {
    case UPDATE_LOADING_STATUS:
      return Object.assign({}, state, {
        loading: action.loading
      });
    case GET_NETWORK:
      return Object.assign({}, state, {
        networkInfo: action.networkInfo
      });
    default:
      return state;
  }
};
